import { render, staticRenderFns } from "./DialogoBuscarClientes.vue?vue&type=template&id=ad1c3a6e&scoped=true&"
import script from "./DialogoBuscarClientes.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1c3a6e",
  null
  
)

export default component.exports